<template>
    <div
        :class="{
            'updateImg-margin': !noMargin,
        }"
        class="updateImg"
        :style="{
            width: width + 'px',
            height: height + 'px',
        }"
    >
        <Upload
            ref="upload"
            :accept="accept"
            name="file"
            type="drag"
            :data="{field}"
            :multiple="multiple"
            :format="['jpeg', 'jpg', 'bmp', 'png', 'JPEG', 'JPG', 'BMP', 'PNG']"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :max-size="maxSize"
            :on-format-error="uploadFormatError"
            :on-exceeded-size="uploadSize"
            :action="url"
            :before-upload="beforeUpload"
        >
            <div v-if="!imgSrc && item" class="imgbox">
                <veui-icon class="imgbox-add" name="plus"/>
                上传形象照
            </div>
            <div v-if="imgSrc && item" class="imgbox">
                <div
                    class="imglist"
                    :style="{
                        width: width - 2 + 'px',
                        height: height - 2 + 'px',
                    }"
                >
                    <img :src="imgSrc"/>
                </div>
                <div class="reload">
                    <div class="reload-box">
                        <div @click.stop="previewImgSrc"><veui-icon class="reload-box-icon" name="eye"/></div>
                        <div><veui-icon class="reload-box-icon" name="upload"/></div>
                        <div @click.stop="clearImgSrc"><veui-icon class="reload-box-icon" name="trash"/></div>
                    </div>
                </div>
            </div>
        </Upload>
        <veui-dialog
            class="dialog"
            overlay-class="cropper-avator-dialog"
            ui="auto"
            :title="cropModalTitle"
            :open.sync="cropper.show"
            :before-close="crop"
        >
            <div class="cropper-tip">为满足头像展示要求，请您参照框线放置人脸，切勿超出标线，留白处系统会自动抠图处理，以达到最佳呈现效果。</div>
            <div class="cropper">
                <vue-cropper
                    ref="cropper"
                    :img="cropper.img"
                    :can-scale="cropper.canScale"
                    :output-size="cropper.outputSize"
                    :output-type="cropper.outputType"
                    :info="cropper.info"
                    :full="cropper.full"
                    :can-move="cropper.canMove"
                    :can-move-box="cropper.canMoveBox"
                    :original="cropper.original"
                    :auto-crop="cropper.autoCrop"
                    :auto-crop-width="cropper.autoCropWidth"
                    :auto-crop-height="cropper.autoCropHeight"
                    :center-box="cropper.centerBox"
                    :info-true="cropper.infoTrue"
                    :fixed="cropper.fixed"
                    :fixed-box="cropper.fixedBox"
                    :fixed-number="cropper.fixedNumber"
                    :mode="cropper.mode"
                    :enlarge="cropper.enlarge"
                    :limit-min-size="cropper.limitMinSize"
                ></vue-cropper>
                <div class="avatar-border-bg"></div>
                <div class="scale-box">
                    <div class="zoom-in" @click="zoomIn">
                    </div>
                    <div class="zoom-out" @click="zoomOut">
                    </div>
                </div>
            </div>
        </veui-dialog>
        <veui-dialog
            :open.sync="previewDialogOpen"
            overlay-class="uploader-preview-dialog"
            footless
            outside-closable
            ui="auto"
        >
            <img :src="imgSrc" style="min-width: 240px; max-width: 480px;">
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @desc 上传组件
 * @author YongZhang<zhangyong06@baidu.com>
 * @file UploadImg.vue
*/
// import AddBox from './AddBox';
import {VueCropper} from 'vue-cropper';
import {Icon, Dialog} from 'veui';
import 'veui-theme-dls-icons';
/**
 * 默认裁剪配置
 */
export const cropperOptions = {
    img: '', // 裁剪图片的地址
    outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
    outputType: 'png', // 裁剪生成图片的格式（jpeg || png || webp）
    info: true, // 图片大小信息
    canScale: true, // 图片是否允许滚轮缩放
    autoCrop: true, // 是否默认生成截图框
    autoCropWidth: 540, // 默认生成截图框宽度
    autoCropHeight: 540, // 默认生成截图框高度
    fixed: true, // 是否开启截图框宽高固定比例
    fixedNumber: [1, 1], // 截图框的宽高比例
    full: false, // false按原比例裁切图片，不失真
    fixedBox: true, // 固定截图框大小，不允许改变
    canMove: true, // 上传图片是否可以移动
    canMoveBox: false, // 截图框能否拖动
    original: false, // 上传图片按照原始比例渲染
    centerBox: false, // 截图框是否被限制在图片里面
    height: false, // 是否按照设备的dpr 输出等比例图片
    infoTrue: true, // true为展示真实输出图片宽高，false展示看到的截图框宽高
    enlarge: 2 // 图片根据截图框输出比例倍数
};

export default {
    name: 'UpdateImg',
    // 上传文案，上传主体如头像、身份证照片等、上传文件大小限制、图片是否非必须
    props: {
        width: {
            'type': [Number, String],
            'default': 120
        },
        height: {
            'type': [Number, String],
            'default': 120
        },
        text: {
            'type': String,
            'default': ''
        },
        item: {
            'type': String,
            'default': ''
        },
        maxSize: {
            'type': Number,
            'default': 10240000
        },
        accept: {
            'type': String,
            'default': 'image/jpeg,image/jpg,image/bmp,image/png'
        },
        imgSrc: {
            'type': String,
            'default': ''
        },
        type: {
            'type': String,
            'default': ''
        },
        defaultImg: {
            'type': String,
            'default': ''
        },
        isNotEssential: {
            'type': Boolean,
            'default': false
        },
        isFromUC: {
            'type': Boolean,
            'default': false
        },
        field: {
            'type': String,
            'default': ''
        },
        idx: {
            'type': Number,
            'default': undefined
        },
        noMargin: {
            'type': Boolean,
            'default': false
        },
        multiple: {
            'type': Boolean,
            'default': false
        },
        isCropped: {
            'type': Boolean,
            'default': false
        },
        cropperOptions: {
            'type': Object,
            'default': () => ({
                ...cropperOptions
            })
        },
        uploadBtnTitle: {
            'type': String,
            'default': '重新上传'
        },
        cropModalTitle: {
            'type': String,
            'default': '操作图片'
        },
        url: {
            'type': String,
            'default': '/bp/api/upload?ajax=1&bdstoken='
        }
    },
    data() {
        return {
            fileData: '',
            num: 0,
            cropper: {
                show: false,
                loading: false,
                ...Object.assign({}, cropperOptions, this.cropperOptions)
            },
            previewDialogOpen: false
        };
    },
    components: {
        'vue-cropper': VueCropper,
        'veui-icon': Icon,
        'veui-dialog': Dialog
    },
    methods: {
        beforeUpload(file) {
            if (this.isFromUC) {
                this.$Message.error('UC用户不可更改');
                return false;
            }
            // 需要裁剪时拦截默认的上传
            if (this.isCropped) {
                this.fileinfo = file;
                this.cropper.img = window.URL.createObjectURL(new Blob([file]));
                this.cropper.show = true;

                return false;
            }
        },
        uploadSuccess(res) {
            if (+res.code === 0) {
                this.num++;
                this.$emit('upload-suc', this.item, res.data.bos_url, this.idx, this.num);
            }
            else {
                this.$Message.error({
                    content: res.msg || '上传失败、请检查网络或重试',
                    duration: 5
                });
            }
        },
        uploadError() {
            this.$Message.error({
                content: '上传失败、请检查网络或重试',
                duration: 5
            });
        },
        uploadFormatError() {
            this.$Message.error({
                content: '文件格式错误,支持jpeg、jpg、bmp、png文件',
                duration: 5
            });
        },
        uploadSize() {
            this.$Message.error({
                content: '文件过大，上传失败',
                duration: 5
            });
        },
        clearImgSrc() {
            this.$emit('upload-suc', this.item, '', this.idx);
        },
        previewImgSrc() {
            this.previewDialogOpen = true;
        },
        // 截图弹窗'确认'事件
        crop(type) {
            if (type === 'ok') {
                const w = this.$refs.cropper.cropW * this.cropper.enlarge;
                const h = this.$refs.cropper.cropH * this.cropper.enlarge;
                if (!(w === h && w >= 0 && h >= 0)) {
                    this.$Message.error({
                        content: '上传图片宽高要求1:1',
                        duration: 3
                    });
                    return false;
                }
                // 获取截图的blob数据
                this.$refs.cropper.getCropBlob(blob => {
                    const file = new File([blob], this.fileinfo.name, this.fileinfo);
                    this.$refs.upload.post(file);
                });
            }
        },
        // 手动放大
        zoomIn() {
            this.$refs.cropper.scale = this.$refs.cropper.scale + 0.05;
        },
        // 手动缩小
        zoomOut() {
            this.$refs.cropper.scale = this.$refs.cropper.scale - 0.05;
        }
    }
};

</script>
<style scoped lang="less">
.updateImg {
    position: relative;
    size: 120px;

    ::v-deep .ivu-upload {
        height: 100%;
    }

    ::v-deep .ivu-upload-drag {
        display: flex;
        width: 120px;
        height: 120px;
        position: relative;
        box-sizing: border-box;
        border: 1px solid #eee;

        &::after {
            border-style: solid;
        }
    }

    .imgbox {
        height: 100%;
        width: 100%;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        line-height: 1;
        color: #848691;

        .imgbox-add {
            height: 16px;
            color: #848691;
            margin-bottom: 10px;
        }

        .imglist {
            display: table-cell;
            vertical-align: middle;
            position: relative;
            height: 120px;
            width: 120px;

            img {
                max-height: 100%;
                max-width: 100%;
            }
        }

        .reload {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            line-height: 120px;
            font-size: 14px;
            color: #fff;
            display: none;

            .reload-box {
                position: absolute;
                width: 100%;
                padding: 4px 12px;
                height: 26px;
                left: 0;
                bottom: 0;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                background: rgba(0, 0, 0, .6);

                div {
                    height: 26px;
                    line-height: 26px;
                    font-size: 12px;
                    margin-left: 12px;
                }
            }
        }

        &:hover .reload {
            display: block;
        }
    }
}

.cropper {
    height: 540px;
    width: 540px;
    margin: 0 auto;
    position: relative;

    &-tip {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 10px;
        color: #f00;
    }
}

.scale-box {
    margin-top: 20px;
    text-align: center;
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 16px;

    .zoom-in {
        height: 30px;
        width: 30px;
        cursor: pointer;
        background: url("https://lvlin-fe-saas.bj.bcebos.com/material/fangda.png") no-repeat center / 100% 100%;
    }

    .zoom-out {
        height: 30px;
        width: 30px;
        cursor: pointer;
        background: url("https://lvlin-fe-saas.bj.bcebos.com/material/suoxiao.png") no-repeat center / 100% 100%;
        margin-left: 20px;
    }
}

.avatar-border-bg {
    background: url("https://lvlin-fe-saas.bj.bcebos.com/material/avatar-border-bg-new.png") no-repeat top center / 100% 100%;
    position: absolute;
    top: 0;
    height: 540px;
    width: 540px;
    pointer-events: none;
}
</style>
<style lang="less">
.cropper-avator-dialog {
    .veui-dialog-content {
        width: 600px;
    }

    .veui-dialog-content-body {
        overflow: hidden;
        padding: 0 30px;
    }

    .veui-dialog-content-foot {
        .veui-button {
            width: 116px;
            height: 36px;
            border-radius: 4px;
            border-radius: 5px;
        }

        .veui-button[ui~="normal"] {
            border: 1px solid #05f;
            background: #fff;
            color: #05f;
            border-radius: 5px;
        }
    }
}
</style>
